import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import type { StepperVariant } from '../stepper'

export const container = css`
  display: flex;
  justify-content: center;

  align-self: start;
  justify-self: center;
  grid-area: icon;
`

export const connectingLine = (theme: Theme, color?: string) => css`
  position: absolute;
  background: ${color ?? theme.palette.tertiary.mediumContrast};
`

export const connectingLineVariant: Record<StepperVariant, ReturnType<typeof css>> = {
  vertical: css`
    height: 100%;
    width: 2px;
    top: 0;
    justify-self: center;
  `,
  horizontal: css`
    width: 100%;
    height: 2px;
    left: 50%;
    align-self: center;
  `,
}
